/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CredentialType } from './CredentialType';
import {
    CredentialTypeFromJSON,
    CredentialTypeFromJSONTyped,
    CredentialTypeToJSON,
} from './CredentialType';
import type { ExportedTOTPCredentialParams } from './ExportedTOTPCredentialParams';
import {
    ExportedTOTPCredentialParamsFromJSON,
    ExportedTOTPCredentialParamsFromJSONTyped,
    ExportedTOTPCredentialParamsToJSON,
} from './ExportedTOTPCredentialParams';

/**
 * 
 * @export
 * @interface ExportedTOTPCredentialAllOf
 */
export interface ExportedTOTPCredentialAllOf {
    /**
     * 
     * @type {CredentialType}
     * @memberof ExportedTOTPCredentialAllOf
     */
    type: CredentialType;
    /**
     * 
     * @type {ExportedTOTPCredentialParams}
     * @memberof ExportedTOTPCredentialAllOf
     */
    params: ExportedTOTPCredentialParams;
    /**
     * 
     * @type {string}
     * @memberof ExportedTOTPCredentialAllOf
     */
    label?: string;
}

/**
 * Check if a given object implements the ExportedTOTPCredentialAllOf interface.
 */
export function instanceOfExportedTOTPCredentialAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "params" in value;

    return isInstance;
}

export function ExportedTOTPCredentialAllOfFromJSON(json: any): ExportedTOTPCredentialAllOf {
    return ExportedTOTPCredentialAllOfFromJSONTyped(json, false);
}

export function ExportedTOTPCredentialAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportedTOTPCredentialAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': CredentialTypeFromJSON(json['type']),
        'params': ExportedTOTPCredentialParamsFromJSON(json['params']),
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}

export function ExportedTOTPCredentialAllOfToJSON(value?: ExportedTOTPCredentialAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': CredentialTypeToJSON(value.type),
        'params': ExportedTOTPCredentialParamsToJSON(value.params),
        'label': value.label,
    };
}

